import { Button, Container, Grid } from '@mui/material';
import html2canvas from 'html2canvas';
import { t } from 'i18next';
import jsPDF from 'jspdf';
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Invoice3 from 'src/components/pdfs/Invoice3';

const DownloadPDF = () => {
  const location = useLocation();
  const data = location.state || {};

  const date = new Date(data[1]?.date);
  const year = date.getFullYear();
  const month = date.toLocaleString('default', { month: 'long' });

  const navigate = useNavigate();
  const generatePdf = () => {
    const page1 = document.getElementById('page1');
    const pdf = new jsPDF('l', 'mm', 'a4');

    html2canvas(page1, { scale: 2 }).then((canvas1) => {
      const imgData1 = canvas1.toDataURL('image/png');
      pdf.addImage(imgData1, 'PNG', 0, 0, 297, 210);
      const page2 = document.getElementById('page2');
      html2canvas(page2, { scale: 2 }).then((canvas2) => {
        const imgData2 = canvas2.toDataURL('image/png');
        pdf.addPage();
        pdf.addImage(imgData2, 'PNG', 0, 0, 297, 210);
        pdf.save(`Inventory_${month}_${year}.pdf`);
      });
      navigate(-1);
    });
  };
  return (
    <Container>
      <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-end', marginTop: 2 }}>
        <Button variant="contained" onClick={generatePdf}>
          {t('common.download')}
        </Button>
      </Grid>
      <Invoice3 data={data} />
    </Container>
  );
};

export default DownloadPDF;
